import React, { forwardRef, useState } from "react";

const gstRegex = /^[0-9]{2}[A-Z]{5}[0-9]{4}[A-Z][1-9A-Z]Z[0-9A-Z]$/;

const GstinSection = forwardRef(
  ({ gstinEnabled, setGstinEnabled, gstinData, setGstinData }, ref) => {
    const [errors, setErrors] = useState({});

    const handleChange = (e) => {
      const { name, value } = e.target;

      // GSTIN specific handling
      if (name === "registrationNumber") {
        // Uppercase + allow only valid characters
        const filteredValue = value
          .toUpperCase()
          .replace(/[^0-9A-Z]/g, "");

        setGstinData((prev) => ({
          ...prev,
          [name]: filteredValue,
        }));

        // Validate only when length = 15
        if (filteredValue.length === 15 && !gstRegex.test(filteredValue)) {
          setErrors((prev) => ({
            ...prev,
            registrationNumber: "Invalid GSTIN",
          }));
        } else {
          setErrors((prev) => ({
            ...prev,
            registrationNumber: "",
          }));
        }

        return;
      }

      // Normal fields
      setGstinData((prev) => ({
        ...prev,
        [name]: value,
      }));
    };

    return (
      <div className="section section-bottom">
        <div className="root_promo_sector">
          <div className="check_box_gstin">

                 <input
                type="checkbox"
                checked={gstinEnabled}
                onChange={() => setGstinEnabled((prev) => !prev)}
              />
              <h6
                className="gstin_title pointer-crusser mb-0" style={{ fontSize:"13px"}}
                onClick={() => setGstinEnabled((prev) => !prev)}
              >
                GSTIN for Business
              </h6>
        
          </div>

          {gstinEnabled && (
            <div className="root_track">
              <div className="coupon-input-container_2">
                <input
                  ref={ref}
                  type="text"
                  name="registrationNumber"
                  value={gstinData.registrationNumber || ""}
                  onChange={handleChange}
                  maxLength={15}
                  className="coupon-input"
                  placeholder="GSTIN Registration Number"
                />
                <p className="error">{errors.registrationNumber}</p>
              </div>

              <div className="coupon-input-container">
                <input
                  type="text"
                  name="companyAddress"
                  value={gstinData.companyAddress || ""}
                  onChange={handleChange}
                  className="coupon-input"
                  placeholder="Registered Company with Address"
                />
              </div>
            </div>
          )}
        </div>
      </div>
    );
  }
);

export default GstinSection;